import { Routes, Route, Navigate } from 'react-router-dom';
import { Shell } from '../layout/Shell.jsx';
import { Protected } from '../shared/Protected.jsx';

// Auto-discover feature routes. Each feature exports a default object:
//   { path, element, protected?, permission?, sidebar?: { label, icon, group } }
// Modules without route.jsx are skipped — Wave 1 agents will add them.
const modules = import.meta.glob('../features/*/route.jsx', { eager: true });

const routes = Object.entries(modules)
  .map(([file, mod]) => {
    const cfg = mod.default;
    if (!cfg || !cfg.path) return null;
    const folder = file.match(/features\/([^/]+)\/route\.jsx$/)?.[1] || cfg.path;
    return { folder, ...cfg };
  })
  .filter(Boolean);

export const featureRoutes = routes;

export function AppRouter() {
  // Routes that should NOT use the Shell (login, public landing, etc.)
  const standalone = routes.filter((r) => r.standalone);
  const withinShell = routes.filter((r) => !r.standalone);

  return (
    <Routes>
      {standalone.map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}

      <Route element={<Shell />}>
        {withinShell.map((r) => {
          const element = r.protected
            ? <Protected permission={r.permission} anyPermission={r.anyPermission}>{r.element}</Protected>
            : r.element;
          return <Route key={r.path} path={r.path} element={element} />;
        })}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
